export type LojaAgregador = {
    name: string
    description: string
    information:string
    order: number
    classificationId: string
    pluginspaceId: number
    image: string | File
    config: config
    corporatename: string
    corporateName: string
    cnpj: string
    link: string
    type: string
    instagram: string
    phoneWhatsapp: string
    active: boolean
    zipCode: string
    exclusive: boolean
}
export type RedeSocial = {
    status: boolean
    link: string
    type: string
}

export type config = {
    address: Address,
    images: Image[]
    product: Product[]
    redesSociais: RedeSocial[]
}

export type Address = {
    city: string
    country: string
    district: string
    number: string
    state: string
    street: string
    extra: string
}

export type Image = {
    image: string | File
}

export type Product = {
    description: string
    image: string
    value:number
    urlExternal?: string
}

export type ImageLoadingState = {
  principal: boolean
  cardOne: boolean
  cardTwo: boolean
  cardThree: boolean
  cardFour: boolean
  cardFive: boolean
  product0: boolean
  product1: boolean
  product2: boolean
  product3: boolean
  product4: boolean
}


export const defaultStore: LojaAgregador = {
    name: '',
    description: '',
    information: '',
    order: 0,
    classificationId: '',
    pluginspaceId: 0,
    image: '',
    config: {
        address: {
            city: '',
            country: '',
            district: '',
            number: '',
            state: '',
            street: '',
            extra: '',
        },
        images: [],
        product: [],
        redesSociais: [],
    },
    corporatename: '',
    corporateName: '',
    cnpj: '',
    link: '',
    type: 'food',
    instagram: '',
    phoneWhatsapp: '',
    active: true,
    zipCode: '',
    exclusive: false,
}